import type { CourseSessionDto } from '@/api/admin'

/**
 * The full update payload for an existing session with only its status changed — what the Publish and
 * Mark completed actions send. The update endpoint replaces every field, so the rest are echoed back unchanged.
 * Shared by the sessions list (quick actions) and the session detail page.
 */
export function sessionStatusUpdate(s: CourseSessionDto, status: CourseSessionDto['status']) {
  return {
    courseId: s.courseId, venueId: s.venue?.id ?? null,
    startsAt: s.startsAt, endsAt: s.endsAt, totalPlaces: s.totalPlaces,
    price: s.price, pricingModel: s.pricingModel, flatFeeAmount: s.flatFeeAmount, flatFeeCapacity: s.flatFeeCapacity,
    notes: s.notes, status,
    additionalDays: s.additionalDays ?? [],
    trainerAssignments: s.trainerAssignments ?? [],
    deliveryMethod: s.deliveryMethod, meetingUrl: s.meetingUrl, meetingInstructions: s.meetingInstructions,
  }
}
